import groupBy from 'ramda/src/groupBy';
import values from 'ramda/src/values';
import pipe from 'ramda/src/pipe';
import prop from 'ramda/src/prop';
const makeRows = pipe(groupBy(pipe(prop('y'), String)), values);
export default makeRows;
//# sourceMappingURL=makeRows.js.map